import styled from 'styled-components';

const ChannelListSynopsisLeftContainer = styled.div<React.CSSProperties>`
  display: flex;
  flex-direction: column;
`;

export default ChannelListSynopsisLeftContainer;
